import React from 'react';
import PropTypes from 'prop-types';
import Text from '../../Global/Text';
import Label from '../../Form/Label';

export const CombinedSummaryError = (props) => {
    const { options, userData, varient, labelStart, labelEnd } = props;
    const { basketList, quotes } = userData;

    const getCombinedText = () => {
        let data = "";
        if(userData["errorCalc-household"]) {
            data+= data === "" ? " <strong>indboforsikring</strong>" : " og <strong>indboforsikring</strong>";
        }
        if(userData["errorCalc-travel"]) {
            data+= data === "" ? " <strong>travelforsikring</strong>" : " og <strong>travelforsikring</strong>";
        }
        if(userData["errorCalc-person"]) {
            data+= data === "" ? " <strong>personforsikring</strong>" : " og <strong>personforsikring</strong>";
        }
        return labelStart + data + labelEnd;
    }

  return (
    <>
    {   varient === "combinedText" ?
        <div>
            <Label label={getCombinedText()}/>
        </div>
        :<ul>
            {
                options.map((item) => {
                    const errorValue = `errorCalc-${item.key}`;
                    const chosenName = `chosenPackage-${item.key}`;
                    const packageName = userData[chosenName];
                    if(basketList.includes(item.key) && !userData[errorValue]
                    && quotes && quotes[packageName]){
                        return (
                        <li key={item.key} className="failed-details">
                            <Text value={item.name}/>
                            <span>{Math.round(userData.quotes[packageName].priceApiResponse[0].offeredPrice.priceWithFee)} </span>
                            <Text value="$[units.$[paymentFrequency]]"/>
                        </li>)
                    }
                })
            }
            
        </ul>
    }
    </>
  );
}